
import Pagination from '@/components/Pagination.vue'
import { defineComponent, getCurrentInstance, toRefs, reactive } from 'vue'
import { useStore } from '@/store/index'
import { getStatisticsList } from '@/apis/coupon'
import { getSaleChannelList } from '@/apis/channel'
import Keys from '@/constant/key'
import { joinParams } from '@/utils/index'

export default defineComponent({
name: 'StatisticsList',
components: {Pagination},
setup() {
    const { proxy } = getCurrentInstance() as any
    const store = useStore()
    
    const state = reactive({
        filters: {
            batch:              '', // 批次号
            sale_channel_id:    '', // 销售渠道 ID
            coupon_no:          '', // 卡券码
            binding_rate:       '', // 绑定率大于
            consumption_rate:   '', // 消耗率大于
            start_valid_at:     '', // 激活开始日期
            end_valid_at:       '', // 激活结束日期
            page:               1,  // 当前页码
            page_size:          10, // 每页条数
        },
        tableData:          [], // 表格数据
        total:              0,  // 表格总条数
        saleChannelList:    [], // 销售渠道列表
        saleListProps:      {   // 销售渠道项属性
            label: 'company_all',
            value: 'id'
        },
    })
        
    // 获取表格数据
    const initData = async () => {
        const { code, data, msg } = await getStatisticsList(state.filters) as any
        if (code != 200) return proxy.$message({ type: 'error', message: msg })
        state.tableData = data.data
        state.total = data.total
    }
    // 搜索
    const onSearch = () => {
        state.filters.page = 1
        initData()
    }
    // 导出
    const onExport = () => {
        window.open(`${Keys.baseUrl}/admin/coupons/export_finance_data?${joinParams({...state.filters, user_id:store.state.user.userInfo.id})}`)
    }
    // 获取销售渠道列表
    const onGetSaleChannelList = async () => {
        const { code, data, msg } = await getSaleChannelList() as any
        if (code != 200) return proxy.$message({ type: 'error', message: msg })
        state.saleChannelList = data
    }
    // 换页
    const onPageChange = (val:number) => {
        state.filters.page = val
        initData()
    }
    const onSizeChange = (val:number) => {
        state.filters.page_size = val
        initData()
    }
    initData()
    onGetSaleChannelList() // 获取销售渠道列表
    return { ...toRefs(state), onPageChange, onSearch, onExport,onSizeChange }
}
})
